export default __webpack_public_path__ + "static/media/bgGreenPuspenerbalMap.b49299aa.png";